module.exports = __webpack_public_path__ + "img/c.08fa785a.png";